import { combineReducers } from 'redux';

import { manualEnforcementReducer as manualEnforcement } from 'redpoints-front-manual-enforcement/ManualEnforcement';
import { dataCompletionReducer as dataCompletion } from 'redpoints-front-data-completion/DataCompletion';

import facilitatorValidation from './facilitatorValidation';
import linksManagement from './linksManagement';
import reportedIncidents from './reportedIncidents';
import shortenerResolution from './shortenerResolution';
import testPurchase from './testPurchase';

const tasks = {
  dataCompletion,
  facilitatorValidation,
  linksManagement,
  manualEnforcement,
  reportedIncidents,
  shortenerResolution,
  testPurchase,
};

export default combineReducers(tasks);
